export default __webpack_public_path__ + "static/screen-1-c21f62cf8fb7a1e9af895de1149e52bb.png";